import React from "react"

import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-qotd.module.scss"
import CopyContainer from "../../atoms/copy-container"

const NewsletterQotd = ({ section }) => {
  const { sanitySettings } = useStaticQuery(graphql`
    {
      sanitySettings {
        default_images {
          quote {
            ...ImageWithPreview
          }
        }
      }
    }
  `)
  return (
    <div className={styles.wrapper}>
      <div className={styles.grid}>
        <div className={styles.left}>
          <Image
            className={styles.mark}
            {...sanitySettings.default_images.quote}
            width={45}
          />
        </div>
        <div className={`${styles.right} ${styles.quote}`}>{section.quote}</div>
      </div>
      <div className={styles.grid}>
        <div className={styles.left}>
          {section.image ? (
            <Image {...section.image} width={125} className={styles.image} />
          ) : (
            ""
          )}
        </div>
        <div className={styles.right}>
          <CopyContainer content={section._rawAttribution} />
        </div>
      </div>
    </div>
  )
}

export default NewsletterQotd

NewsletterQotd.propTypes = {
  section: PropTypes.object.isRequired,
}
